import { z } from 'zod';
export const ListOrgsRequestSchema = z.void();
export const ListOrgsResponseSchema = z.object({
    orgs: z.array(z.object({ name: z.string(), value: z.string() })),
});
export const ListOrgsApiSchema = {
    response: ListOrgsResponseSchema,
};
